module.exports = __webpack_public_path__ + "img/724全时服务能力.3de1b691.png";